// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"4ef92672","498":"eb51ee4b","513":"451a1320","787":"ae88c473"}[chunkId] + ".chunk.js";
};